

























































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
import  dialogPanel  from "./dialogPanel.vue"
import { TbGoodsClass, TbMember } from "@/http";
 @Component({
    components: {dialogPanel},
}) 
export default class changeBalancePanel extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:false
    })
    show:Boolean;
    @Prop({
        type:Object,
        default:()=>{
            return{
                id:"", 
                name:"", 
                phone:"",
                balance:"",
            } 
        }
    })
    memberInfo:any;
   


    title="余额调整";

    isloading=false;

    form={
        balanceChanges:null,
        status:2,
        remarks:"",
    }
    userInfo:any={};

    async mounted() {
       
    }
    async created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }

    async saveFun(){
        if(this.isloading) return;
        if(!this.form.balanceChanges){
            Toast("请输入调整金额");
            return;
        }
        if(Number(this.form.balanceChanges)==0){
            Toast("金额不可为0");
            return;
        }
        if(this.form.status==1&&Number(this.form.balanceChanges)>9999999){
            Toast("余额最多增加9999999");
            return;
        }
        if(this.form.status==2&&Number(this.form.balanceChanges)>Number(this.memberInfo.balance)){
            Toast(`余额最多减少${this.memberInfo.balance}`);
            return;
        }
        try {
            let obj = Object.assign({},this.form,{
                shopId:this.userInfo.shopId,
                memberId:this.memberInfo.id,
                memberName:this.memberInfo.name,
                phone:this.memberInfo.phone,
                balance:this.memberInfo.balance,
                creatorId:this.userInfo.id,
                creatorName:this.userInfo.name,
            })
            let res = await TbMember.AddBalanceAdjustment(obj);
            Toast("新增成功");
            this.isloading = false;
            this.closeFun();
            this.$emit("confirmSave")
        } catch (error) {
            this.isloading = false;
            
        }
    }
    resetForm(){
       this.form={
            balanceChanges:null,
            status:2,
            remarks:"",
       } 
    }
    
    closeFun(){
        this.resetForm();
        this.$emit("closeFun");
    }
    changeStatus(val){
        this.form.status = val;
    }
    handleInput(val){
        let xsIndex = val.toString().indexOf('.');
        if(val<0){
            this.form.balanceChanges = 0;
        }else{
            if(xsIndex>-1){
                if(val.toString().slice(xsIndex+1).length>1){
                    this.form.balanceChanges = this.form.balanceChanges.slice(0,xsIndex+3)
                }
            }else{
                if(val.toString().length>5){
                    this.form.balanceChanges = this.form.balanceChanges.slice(0,5)
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/changeBalancePanel.vue